<ng-container *ngIf="rating !== null">
  <p-rating [(ngModel)]="rating" readonly="true" [stars]="5" [cancel]="false"></p-rating>
  <hr *ngIf="reasons || comment" />
  <div *ngIf="reasons" class="reasons-panel">
    <div class="reason-label">{{ rating < 3 ? 'Disliked:' : 'Liked:' }}</div>
    <div class="reason" *ngFor="let reason of reasons">{{ reason }}</div>
  </div>
  <div *ngIf="comment" class="comment">
    {{ comment | wrap : wrapSize }}&nbsp;<a
      href="#"
      [hidden]="!isShowReadMore()"
      (click)="readMore(); $event.preventDefault()"
      >Read more</a
    >
  </div>
</ng-container>

<p-confirmDialog
  header="Import result"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  [key]="mode"
  [acceptVisible]="false"
  rejectLabel="Close"
></p-confirmDialog>
